// tslint:disable: object-literal-key-quotes

export const en = {
  translation: {
    'Nouvelle organisation': 'New organization',
    home: 'Home',
    new_app: 'Nouvelle application',
    segment: 'Segments',

    search_app: 'Rechercher une application',
    add_segment: 'Add new segment',
    new_job: 'Add a new job',
    new_role: 'Add new role',
    email: 'Email',

    phone: 'Phone number',
    label: 'Label',
    url: 'Url',
    firstName: 'First name',
    lastName: 'Last name',
    Role: 'Role',
    new_user: 'Add new user',
    search_org: 'Search an organizaton',
    edit_profil: 'Edit profil',
    password: 'Password',
    configure_auth: 'Configure double authentication',
    configure_auth_desc: 'Two-factor authentication adds an additional layer of protection to connections. Once activated and configured, every time you log in, you will be asked to enter your username, password and a two-factor code.',
    double_auth: 'Double authentification',
    enable: 'enable',
    disabled: 'disabled',
    new_org: 'Add an organizaton',
    update: 'Update',
    delete: 'Delete',
    validate: 'Validate',
    cancel: 'Cancel',
    send: 'Send',
    email_error: 'Email format not valide',
  },
}
